export const QUIZ = '/quiz_assessment/'
export const QUIZ_ALL = `${QUIZ}all` as const

export const QUIZ_CACHE = `${QUIZ}cache/` as const
export const QUIZ_CACHE_ALL = `${QUIZ_CACHE}all` as const

export const QUIZ_PUBLISH = `${QUIZ}publish` as const

export const QUIZ_RESET_OPEN = `${QUIZ}reset/open` as const
export const QUIZ_RESET_OPEN_ALL = `${QUIZ_RESET_OPEN}/all` as const

export const QUIZ_RESULT_OPEN = `${QUIZ}result/open` as const
export const QUIZ_RESULTS = `${QUIZ}results` as const
export const QUIZ_RESULT = `${QUIZ}result/` as const

export const QUIZ_TYPES = `${QUIZ}types` as const
